/* KINESIA — interacciones (sin librerías) */
(function () {
  if (window.__knInit) return;
  window.__knInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll + barras de progreso ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.kn-reveal:not(.is-in), .kn-progress:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); countUp(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function countUp(el) {
    var num = el.querySelector ? el.querySelector('[data-kn-count]') : null;
    if (!num || num.dataset.knDone) return;
    num.dataset.knDone = '1';
    var target = parseInt(num.dataset.knCount, 10) || 0;
    if (reduceMotion || target === 0) { num.textContent = target; return; }
    var start = null, dur = 1200;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      num.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Cuentas atrás (un solo temporizador para todas) ---------- */
  function initCountdowns() {
    if (window.__knCd) return;
    window.__knCd = true;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = Date.now();
      var cds = Array.prototype.slice.call(document.querySelectorAll('[data-kn-deadline]'));
      cds.forEach(function (cd) {
        var end = Date.parse(cd.dataset.knDeadline);
        if (isNaN(end)) return;
        var diff = end - now;
        if (diff <= 0) {
          if (!cd.classList.contains('is-closed')) {
            cd.classList.add('is-closed');
            document.querySelectorAll('[data-kn-close-disable]').forEach(function (b) {
              b.setAttribute('disabled', 'disabled');
              b.classList.add('is-disabled');
              if (b.dataset.knClosedText) b.textContent = b.dataset.knClosedText;
            });
          }
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var set = function (k, v) { var n = cd.querySelector('[data-kn-' + k + ']'); if (n && n.textContent !== v) n.textContent = v; };
        set('d', '' + d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
        cd.classList.toggle('is-urgent', d < 3);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Hero: selector de modelo + inclinación 3D ---------- */
  function initHero() {
    document.querySelectorAll('[data-kn-hero]').forEach(function (hero) {
      if (hero.dataset.knReady) return;
      hero.dataset.knReady = '1';
      var slides = hero.querySelectorAll('[data-kn-slide]');
      var swatches = hero.querySelectorAll('[data-kn-swatch]');
      var infos = hero.querySelectorAll('[data-kn-info]');
      var stage = hero.querySelector('.kn-stage');
      if (!slides.length || !stage) return;
      var current = 0;

      function go(i) {
        current = (i + slides.length) % slides.length;
        [slides, swatches, infos].forEach(function (list) {
          list.forEach(function (el, idx) {
            var on = idx === current;
            el.classList.toggle('is-active', on);
            if (el.hasAttribute('aria-selected')) el.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
        var color = slides[current].dataset.knColor;
        if (color) stage.style.setProperty('--kn-stage-color', color);
        var info = infos[current];
        if (info) initReveal(info);
      }

      swatches.forEach(function (sw, i) { sw.addEventListener('click', function () { go(i); stopAuto(); }); });
      var prev = hero.querySelector('[data-kn-prev]');
      var next = hero.querySelector('[data-kn-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); stopAuto(); });
      if (next) next.addEventListener('click', function () { go(current + 1); stopAuto(); });

      // Deslizar con el dedo
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); stopAuto(); }
        sx = null;
      });

      // Cambio automático suave (se para en cuanto el usuario interactúa)
      var autoMs = parseInt(hero.dataset.knAuto, 10) || 0;
      var timer = null;
      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
      if (autoMs > 0 && !reduceMotion && slides.length > 1) {
        timer = setInterval(function () { go(current + 1); }, autoMs);
        hero.addEventListener('pointerenter', stopAuto, { once: true });
      }

      // Inclinación 3D siguiendo el ratón (solo con ratón y sin "reducir movimiento")
      var maxTilt = parseFloat(hero.dataset.knTilt) || 0;
      if (maxTilt > 0 && !reduceMotion && window.matchMedia('(hover: hover)').matches) {
        var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
        function loop() {
          cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
          stage.querySelectorAll('.kn-stage__tilt').forEach(function (t) {
            t.style.setProperty('--kn-rx', cy.toFixed(2) + 'deg');
            t.style.setProperty('--kn-ry', cx.toFixed(2) + 'deg');
          });
          if (Math.abs(tx - cx) > 0.01 || Math.abs(ty - cy) > 0.01) raf = requestAnimationFrame(loop); else raf = null;
        }
        stage.addEventListener('pointermove', function (e) {
          var r = stage.getBoundingClientRect();
          tx = ((e.clientX - r.left) / r.width - 0.5) * 2 * maxTilt;
          ty = -((e.clientY - r.top) / r.height - 0.5) * 2 * maxTilt;
          if (!raf) raf = requestAnimationFrame(loop);
        });
        stage.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
      }

      go(0);
    });
  }

  /* ---------- Página de producto: galería + variantes ---------- */
  function initPdp() {
    document.querySelectorAll('[data-kn-pdp]').forEach(function (pdp) {
      if (pdp.dataset.knReady) return;
      pdp.dataset.knReady = '1';
      var main = pdp.querySelector('[data-kn-main]');
      pdp.querySelectorAll('[data-kn-thumb]').forEach(function (th) {
        th.addEventListener('click', function () {
          pdp.querySelectorAll('[data-kn-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          th.classList.add('is-active');
          if (!main) return;
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = th.dataset.knSrc;
            main.srcset = '';
            main.style.opacity = '1';
          }, 160);
        });
      });

      var dataEl = pdp.querySelector('[data-kn-variants]');
      var select = pdp.querySelector('[data-kn-variant-select]');
      if (!dataEl || !select) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = pdp.querySelector('input[name="id"]');
      var priceEl = pdp.querySelector('[data-kn-price]');
      var btn = pdp.querySelector('[data-kn-add]');
      select.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_formatted;
        if (btn && !btn.classList.contains('is-closed')) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.dataset.knText : btn.dataset.knSoldText;
        }
      });
    });
  }


  /* ---------- Menú: desplazamiento suave con aceleración (baja y te lleva) ---------- */
  function initSmoothScroll() {
    if (window.__knScroll) return;
    window.__knScroll = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash || url.hash.length < 2) return;
      var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('[data-kn-header]');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 12;
      var startY = window.scrollY;
      var endY = Math.max(0, target.getBoundingClientRect().top + startY - offset);
      var dist = endY - startY;
      if (reduceMotion || Math.abs(dist) < 4) { window.scrollTo(0, endY); }
      else {
        var dur = Math.min(1100, Math.max(550, Math.abs(dist) * 0.45));
        var t0 = null;
        var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
        document.documentElement.style.scrollBehavior = 'auto';
        var step = function (now) {
          if (!t0) t0 = now;
          var p = Math.min((now - t0) / dur, 1);
          window.scrollTo(0, startY + dist * ease(p));
          if (p < 1) requestAnimationFrame(step);
          else { document.documentElement.style.scrollBehavior = ''; target.classList.add('kn-arrived'); setTimeout(function () { target.classList.remove('kn-arrived'); }, 900); }
        };
        requestAnimationFrame(step);
      }
      history.pushState(null, '', url.hash);
    });
  }

  /* ---------- Formas de reservar: el botón dice cuánto pagas hoy ---------- */
  function initPlans() {
    document.querySelectorAll('[data-kn-plans]').forEach(function (box) {
      if (box.dataset.knReady) return;
      box.dataset.knReady = '1';
      var form = box.closest('form');
      var btn = form && form.querySelector('[data-kn-add]');
      box.addEventListener('change', function (e) {
        var r = e.target;
        if (!btn || !r.dataset.knButton || btn.disabled) return;
        btn.dataset.knText = r.dataset.knButton;
        btn.style.opacity = '0.6';
        setTimeout(function () { btn.textContent = r.dataset.knButton; btn.style.opacity = ''; }, 120);
      });
    });
  }

  function boot() { initReveal(); initCountdowns(); initHero(); initPdp(); initSmoothScroll(); initPlans(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Editor de Shopify: re-inicializar al recargar una sección
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initHero(); initPdp(); initPlans(); });
})();
